var _rect, _circle, _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsFallback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 450",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "BigSport") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    fill: "#111827"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 188,
    r: 74,
    fill: "#facc15"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M363 188h74M400 151v74",
    stroke: "#111827",
    strokeWidth: 18,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 310,
    fill: "#fff",
    fontFamily: "Arial, sans-serif",
    fontSize: 54,
    fontWeight: 700,
    textAnchor: "middle"
  }, "BigSPORT")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsFallback);
export default __webpack_public_path__ + "static/media/news-fallback.290a25468cc75e84c475c7dc63ea410a.svg";
export { ForwardRef as ReactComponent };